import PropTypes from 'prop-types';
import React from 'react';

// eslint-disable-next-line no-unused-vars
const Tab = ({ tabKey, title, children, className }) =>
  <div className={className}>
    {children}
  </div>;

Tab.propTypes = {
  tabKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Tab;
